export default "__VITE_ASSET__BeFOSiEC__"